import { gql } from "@apollo/client";

export const getDocumentConfigQuery = gql`
query($isArchived: Boolean!, $objectType: String!){
  getDocumentConfigByObject(isArchived: $isArchived, objectType: $objectType) {
    response
    message
  }
}
`;